import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
// ========================================== 登录鉴权 ==========================================
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg)) return unescape(arr[2]);else return null;
}
function setCookie(name, value) {
  var Days = 30;
  var exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

// 获取登录凭证
export var getLoginAuth = function getLoginAuth() {
  return getCookie('pmv5-csrftoken');
};

// 清除登录凭证
export var clearLoginAuth = function clearLoginAuth() {
  delCookie('pmv5-csrftoken');
};